import { faCashRegister } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Col, Row, Button, Form, InputGroup } from "react-bootstrap";
import { registraCajaChica } from "../../../api/cajaChica";
import { toast } from "react-toastify";
import { obtenerUsuario } from "../../../api/usuarios";
import { getTokenApi, obtenidusuarioLogueado } from "../../../api/auth";
import { subeArchivosCloudinary } from "../../../api/cloudinary";

const RegistroDineroMantenimiento = ({ balance }) => {
  const [concepto, setConcepto] = useState("");
  const [cantidad, setCantidad] = useState("");
  const [tipo, setTipo] = useState("");
  const [archivo, setArchivo] = useState(null);

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  useEffect(() => {
    console.log(archivo);
  }, [archivo]);

  const [nombreUsuario, setNombreUsuario] = useState("");

  const obtenerDatosUsuario = () => {
    try {
      obtenerUsuario(obtenidusuarioLogueado(getTokenApi()))
        .then((response) => {
          const { data } = response;
          setNombreUsuario(data.nombre + "/" + data.email);
        })
        .catch((e) => {
          if (e.message === "Network Error") {
            //console.log("No hay internet")
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    obtenerDatosUsuario();
  }, []);

  const obtenerFechaActual = () => {
    const fecha = new Date();
    const year = fecha.getFullYear();
    let mes = fecha.getMonth() + 1;
    let dia = fecha.getDate();
    let hora = fecha.getHours();
    let minutos = fecha.getMinutes();
    let segundos = fecha.getSeconds();

    mes = mes < 10 ? `0${mes}` : mes;
    dia = dia < 10 ? `0${dia}` : dia;
    hora = hora < 10 ? `0${hora}` : hora;
    minutos = minutos < 10 ? `0${minutos}` : minutos;
    segundos = segundos < 10 ? `0${segundos}` : segundos;

    return `${year}-${mes}-${dia} ${hora}:${minutos}:${segundos}`;
  };

  const registro = () => {
    if (!concepto || !cantidad) {
      toast.warning("Datos incompletos");
    } else {
      if (tipo === "Salida") {
        if (parseFloat(cantidad) <= balance) {
          if (archivo) {
            subeArchivosCloudinary(archivo, "laboratorio")
              .then((response) => {
                const { data } = response;
                const { secure_url } = data;
                registraSalida(secure_url);
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            registraSalida("");
          }
        } else {
            toast.warning("La cantidad de salida excede el balance disponible en caja");
        }
      } else {
        if (archivo) {
          subeArchivosCloudinary(archivo, "laboratorio")
            .then((response) => {
              const { data } = response;
              const { secure_url } = data;
              registraSalida(secure_url);
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          registraSalida("");
        }
      }
    }
  };

  const registraSalida = (linkArchivo) => {
    try {
      const fechaActual = obtenerFechaActual();
      const dataTempIns = {
        idUsuario: nombreUsuario,
        fechayHora: fechaActual,
        concepto: concepto,
        cantidad: cantidad,
        tipo: "Salida",
        comprobante: linkArchivo,
        estado: "2",
      };
      registraCajaChica(dataTempIns).then((response) => {
        const { data } = response;
        toast.success(data.mensaje);
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <Form>
        <Row className="mb-2 mb-md-4 mb-lg-7">
          <Col
            sm={12}
            md={4}
            lg={4}
            className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
          >
            <Form.Label>Concepto: <code>*</code></Form.Label>
          </Col>
          <Col sm={12} md={8} lg={8}>
            <Form.Control
              type="text"
              placeholder="Ingresa el concepto de la operación"
              value={concepto}
              onChange={(e) => setConcepto(e.target.value)}
            />
          </Col>
        </Row>

        <Row className="mb-2 mb-md-4 mb-lg-7">
          <Col
            sm={12}
            md={4}
            lg={4}
            className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
          >
            <Form.Label>Cantidad: <code>*</code></Form.Label>
          </Col>
          <Col sm={12} md={8} lg={8}>
            <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control
                value={cantidad}
                onChange={(e) => {
                  let inputValue = e.target.value;
                  if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCantidad(inputValue);
                  }
                }}
                placeholder="Ingresa la cantidad de la operación"
              />
            </InputGroup>
          </Col>
        </Row>
        <Row className="mb-2 mb-md-4 mb-lg-7">
          <Col
            sm={12}
            md={4}
            lg={4}
            className="d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end"
          >
            <Form.Label>Comprobante: <code>*</code></Form.Label>
          </Col>
          <Col sm={12} md={8} lg={8}>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              accept="image/png, image/jpeg, .pdf"
            />
          </Col>
        </Row>
      </Form>
      <div className="d-flex justify-content-center">
        <Button variant="success" onClick={registro}>
          <FontAwesomeIcon icon={faCashRegister} /> Registrar
        </Button>
      </div>
    </div>
  );
};

export default RegistroDineroMantenimiento;
